import { fallbackLng } from "@/i18n/settings";

type RouteParams = {
  [key: string]: string | string[] | undefined;
};

export function getLocaleFromURLParams(params: RouteParams) {
  const locale = Array.isArray(params.lang) ? params.lang[0] : params.lang;

  return locale || fallbackLng;
}
